<template>
  <div class="notifications-container">
    <NotificacionCard
      v-for="notification in notificaciones"
      :key="notification.Id"
      :notificacion="notification"
      :leida="leida"
      @notificacion-leida="refrescarNotificaciones"
    /> 
  </div>
</template>

<script setup lang="ts">
import NotificacionCard from './NotificacionCard.vue';
import type { NotificacionModel } from '@/.shared/.api/api';

const props = defineProps({
  notificaciones: {
    type: Array as () => NotificacionModel[],
    required: true
  },
  leida: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['refrescar-notificaciones']);

const refrescarNotificaciones = () => {
  emit('refrescar-notificaciones');
}
</script>

<style scoped>

</style>
